<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" :fill="fillColor">
    <g>
      <path
        d="M12,21a9,9,0,1,1,9-9A9,9,0,0,1,12,21ZM12,4.5A7.5,7.5,0,1,0,19.5,12,7.5,7.5,0,0,0,12,4.5Z"
      />
      <path
        d="M16,12.75a.74.74,0,0,1-.53-.22L12,9.06,8.53,12.53a.75.75,0,0,1-1.06-1.06l4-4a.75.75,0,0,1,1.06,0l4,4a.75.75,0,0,1,0,1.06A.74.74,0,0,1,16,12.75Z"
      />
      <path
        d="M12,16.75a.76.76,0,0,1-.75-.75V8a.75.75,0,0,1,1.5,0v8A.76.76,0,0,1,12,16.75Z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    fillColor: {
      type: String,
      required: false,
    },
  },
};
</script>
